/* site/placeholderImg.js — the prototype's image fallback (lhc-landing-page.html,
 * inline script 1): photo placeholders come from picsum; when one cannot load
 * (offline, blocked, sandboxed viewer) the <img> is swapped for an embedded
 * tonal panel carrying the seed's label, so the composition never shows a
 * broken image. Ported verbatim in behaviour; used through onError below. */
const TONES = [
  ["#EFEAE1", "#E3DCCF", "#6E6559"], ["#D6CDBE", "#C9BFAE", "#5C544A"], ["#B9AE9C", "#A89D8B", "#3B352E"],
  ["#8C8275", "#7A7165", "#F3EFE8"], ["#5E5750", "#4F4942", "#E9E3D8"], ["#2B2721", "#221F1A", "#CFC7BA"],
];

export function lhcSvg(seed, w, h) {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  const t = TONES[hash % TONES.length];
  const label = String(seed).replace(/^lhc-/, "").replace(/-?(hero|tech|gallery|page|detail|piece|pd|res|new)-?/g, " ")
    .replace(/-\d+$/, "").replace(/[-_]+/g, " ").replace(/\s+/g, " ").trim().toUpperCase() || "LHC";
  const m = Math.min(w, h), wide = w > 1.4 * h;
  const f = Math.max(10, Math.round(m * (wide ? 0.032 : 0.045)));
  const f2 = Math.max(7, Math.round(m * (wide ? 0.022 : 0.03)));
  const ins = Math.round(m * 0.06), cm = Math.round(m * 0.05);
  const sub = wide ? "PLACEHOLDER" : "PLACEHOLDER — LHC PHOTOGRAPHY TO FOLLOW";
  const c = (d) => `<path d="${d}" stroke="${t[2]}" stroke-opacity=".45" fill="none"/>`;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}">`
    + `<defs><linearGradient id="g" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${t[0]}"/><stop offset="1" stop-color="${t[1]}"/></linearGradient></defs>`
    + `<rect width="${w}" height="${h}" fill="url(#g)"/>`
    + c(`M${ins} ${ins + cm}V${ins}H${ins + cm}`) + c(`M${w - ins - cm} ${ins}H${w - ins}V${ins + cm}`)
    + c(`M${ins} ${h - ins - cm}V${h - ins}H${ins + cm}`) + c(`M${w - ins - cm} ${h - ins}H${w - ins}V${h - ins - cm}`)
    + `<text x="${w / 2}" y="${h / 2}" text-anchor="middle" font-family="Helvetica,Arial,sans-serif" font-size="${f}" letter-spacing="${f * 0.18}" fill="${t[2]}" fill-opacity=".9">${label}</text>`
    + `<text x="${w / 2}" y="${h / 2 + f2 * 1.9}" text-anchor="middle" font-family="Helvetica,Arial,sans-serif" font-size="${f2}" letter-spacing="${f2 * 0.2}" fill="${t[2]}" fill-opacity=".55">${sub}</text></svg>`;
  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
}

/** onError for any picsum placeholder <img>: swap in the tonal panel, once. */
export function onPlaceholderError(e) {
  const el = e && e.currentTarget;
  if (!el || el.dataset.phDone) return;
  const m = (el.getAttribute("src") || "").match(/picsum\.photos\/seed\/([^/]+)\/(\d+)\/(\d+)/);
  if (!m) return;
  el.dataset.phDone = "1";
  el.src = lhcSvg(decodeURIComponent(m[1]), +m[2], +m[3]);
}
